//
import { mapActions, mapState } from "vuex"
import { ModelDataTable, VBtnAction } from "@/components/reusable_components/next"

//
import PurchaseOrderEditedService from '@/services/api/Purchase/PchPurchaseOrderEdited'
import TranslatorService from '@/services/translator'

//
import filters from './filters'
import headers from './headers'

//
export default {
    name: 'purchase-order-edited-list',
    components: {
        ModelDataTable,
        VBtnAction,
    },
    computed: {
        /**
         *
         */
        tableProps() {
            return {
                service: new PurchaseOrderEditedService().toList(),
                filters,
                headers,
                rowsPerPage: 25,
            }
        },

        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    data() {
        return {
            selected: null,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setItemsTopBar: 'setItemsTopBar',
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            setErrorSnackbar: 'setErrorSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
            setWarningSnackbar: 'setWarningSnackbar',
        }),

        /**
         *
         */
        authorize() {
            return this.selected
                .authorize()
                .attach()
                .then(this.successAuthorize)
                .then(this.refresh)
                .catch(this.error)
        },

        /**
         * @description
         *
         */
        error(error) {
            this.setErrorSnackbar(
                TranslatorService(this.tableProps.service.resource(), error.response.data)
            )
        },

        /**
         *
         */
        refresh() {
            this.$refs.table.refresh()
        },

        /**
         * @description
         *
         */
        submitAuthorize(event) {
            //
            this.selected = event.item

            //
            this.setWarningSnackbar({
                title: 'Autorizar',
                message:
                    '¿Confirma la autorización de la edición de la orden de compra?',
                confirm: 'autorizar',
            })
        },

        /**
         * @description
         *
         */
        submitCreate() {
            this.$router.push({ name: 'purchase-order-edited-create' })
        },

        /**
         *
         */
        submitRemove(event) {
            //
            this.setWarningSnackbar({
                confirm: 'eliminar',
                message: `¿Confirma la eliminación de la edición de orden de compra #${event.item.pch_purchase_order_id}?`,
                title: 'Eliminar',
            })

            //
            this.selected = event.item
        },

        /**
         *
         */
        submitUpdate(event) {
            this.$router.push({
                name: 'purchase-order-edited-update',
                params: { id: event.item.id },
            })
        },

        /**
         * @description
         *
         */
        success() {
            this.setSuccessSnackbar(
                'Edición de orden de compra eliminada exitosamente.'
            )
        },

        /**
         * @description
         *
         */
        successAuthorize() {
            this.setSuccessSnackbar(
                'Edición de orden de compra autorizada exitosamente.'
            )
        },
    },
    beforeMount() {
        // set the view title
        this.setTitleTopBar('Ordenes de compra editadas')

        // set the view top bar items
        this.setItemsTopBar([
            {
                action: this.submitCreate,
                color: 'accent',
                icon: 'add_circle',
                text: 'editar órden de compra autorizada',
                tip: 'Editar una órden de compra autorizada',
                can: 'CREATE_EDITED_PURCHASE_ORDER',
            },
        ])
    },
    watch: {
        /**
         *
         */
        responseConfirm(val) {
            switch (val) {
                case 'autorizar':
                    return this.authorize()
                case 'eliminar':
                    return this.selected
                        .delete()
                        .then(this.success)
                        .then(this.$refs.table.refresh)
                        .catch(this.error)
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_EDITED_PURCHASE_ORDER'))
                ctx.$router.push('/')
        })
    },
}
